import React from 'react'
import './body.css'
import Phone from '../../Images/Larger devices/Group 53.png'
import Line from '../../Images/Larger devices/HR.png'

function Body() {
  return (
    <div className='boss text-center'>
      <img className='fit' src={Phone} alt='' />
      <img className='cur' src={Line} alt='' />
      <h4 className='app'>How the app works</h4>
    </div>
  )
}

export default Body
